'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import scriptLoader from 'react-async-script-loader';
import GpsUtils from './GpsUtils';

class ElevationChart extends React.Component {
  static propTypes = {
    data: PropTypes.array.isRequired,
    raceId: PropTypes.number.isRequired,
    moveCursor: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.eleMin = Infinity;
    this.eleMax = 0;
  }

  distanceEleStream() {
    const data = this.props.data;
    let distance = 0;
    let distanceEleStream = [];

    // Fix patchy elevation data
    const cleanedData = this.smoothElevationDataPoints(data);

    for (let i = 0; i < cleanedData.length; i++) {
      if (i !== 0) {
        const pp = cleanedData[i - 1];
        const dist = GpsUtils.distanceBetweenPoints(cleanedData[i], pp);
        distance += dist;
      }

      const ele = cleanedData[i].ele;
      distanceEleStream.push([distance / 1000, ele]);

      if (ele < this.eleMin) {
        this.eleMin = ele;
      }

      if (ele > this.eleMax) {
        this.eleMax = ele;
      }
    }
    return distanceEleStream;
  }

  smoothElevationDataPoints(data) {
    const length = data.length;
    for (let i = 0; i < data.length; i++) {
      if (data[i].ele > 0) {
        // Skip if elevation present
        continue;
      }

      // Find next available datapoint
      const next = data.slice(i, length).findIndex((e) => e.ele > 0);

      // Interpolation missing data with previous and next datapoint
      if (next > 0) {
        data[i].ele = (data[i - 1].ele + data[next + i].ele) / 2;
      }
    }

    return data;
  }

  componentWillReceiveProps({ isScriptLoaded, isScriptLoadSucceed }) {
    if (isScriptLoaded && !this.props.isScriptLoaded) {
      // load finished
      if (isScriptLoadSucceed) {
        this.chart();
      }
    }
  }

  tooltipFormatter(tooltip) {
    let res = [];
    res.push('<b>Dist:</b> ' + Math.round(tooltip.x * 10) / 10 + ' km');
    for (let i = 0; i < tooltip.points.length; i++) {
      const point = tooltip.points[i];
      if (point.series.name === 'Ele') {
        res.push('<b>Alt:</b> ' + Math.round(point.y) + ' m');
      }
    }
    return res.join('<br />');
  }

  tooltipPositioner(labelWidth, labelHeight, point, chart) {
    let xPos;
    if (chart.plotSizeX - point.plotX < 125) {
      if (labelWidth > 102) {
        xPos = point.plotX - 77;
      }
    } else {
      xPos = point.plotX + 70;
    }
    return { x: xPos, y: 40 };
  }

  xAxisFormatter(value) {
    return value + ' km';
  }

  yAxisFormatter(value) {
    return value + ' m';
  }

  eventMouseOver(obj) {
    const index = obj.series.data.indexOf(obj);
    this.props.moveCursor(index);
  }

  chart() {
    let that = this;
    let chart = new Highcharts.Chart({
      chart: {
        renderTo: 'chart-canvas-' + this.props.raceId,
        alignTicks: true,
        ignoreHiddenSeries: true,
        type: 'splice',
        zoomType: 'xy'
      },
      title: { text: '' },
      credits: { enabled: false },
      series: [
        {
          name: 'Ele',
          data: this.distanceEleStream(),
          yAxis: 0,
          color: '#efefef',
          lineWidth: 1,
          type: 'area',
          fillColor: '#be1723',
          zIndex: 1,
          showInLegend: false,
          fillOpacity: 1,
        },
      ],
      tooltip: {
        shared: true,
        followPointer: true,
        animation: false,
        borderColor: '#CBCBCB',
        shadow: false,
        hideDelay: 0,
        formatter: function () {
          return that.tooltipFormatter(this);
        },
        positioner: function (labelWidth, labelHeight, point) {
          return that.tooltipPositioner(labelWidth, labelHeight, point, chart);
        },
      },
      plotOptions: {
        series: {
          marker: { enabled: false },
          point: {
            events: {
              mouseOver: function () {
                that.eventMouseOver(this);
              },
            },
          },
          states: {
            hover: { enabled: false },
          },
        },
      },

      xAxis: {
        labels: {
          style: {
            color: '#494949',
            fontSize: '11px',
          },
          formatter: function () {
            return that.xAxisFormatter(this.value);
          },
        },
        crosshair: {
          zIndex: 5,
          color: '#AAA',
        },
        lineColor: '#be1723',
        lineWidth: 1,
        maxPadding: 0,
        minPadding: 0,
        min: 0,
        gridLineWidth: 0,
        gridLineColor: '#EEE',
        tickLength: 0,
        tickInterval: 1,
      },

      yAxis: [
        {
          lineWidth: 1,
          lineColor: '#be1723',
          title: { text: null },
          labels: {
            formatter: function () {
              return that.yAxisFormatter(this.value);
            },
          },
          min: this.eleMin - 15,
          max: this.eleMax + 50,
          minRange: 0.1,
          gridLineWidth: 0,
          gridLineColor: '#EEE',
          tickInterval: Math.max((this.eleMax - this.eleMin) / 50, 50),
          tickLength: 0,
        },
      ],
    });
    return chart;
  }

  render() {
    return <div className='chart-canvas' id={'chart-canvas-' + this.props.raceId} />;
  }
}

export default scriptLoader('https://code.highcharts.com/highcharts.js')(ElevationChart);
